<template>
  <span>
    <div class="top-buttons">
      <button
        class="btn"
        :class="{ 'btn-success': selectedTime === item.alias }"
        v-for="item in buttonsOpt"
        :key="item.alias"
        @click="chooseTimeFrame(item.alias)"
      >
        {{ item.name }}
      </button>
      <button
        class="btn"
        :class="{ 'btn-success': selectedTime === null }"
        @click="chooseTimeFrame(null)"
      >
        {{ "Custom" }}
      </button>
    </div>
    <div class="multi-chart" id="multi-countries-chart"></div>
  </span>
</template>

<script>
export default {
  name: "countriesChart",
  props: {
    data: {
      type: Object,
      required: true
    },
    sortedBy: {
      required: true
    }
  },
  data() {
    return {
      mainCanvas: "multi-countries-chart",
      selectedTime: null,
      buttonsOpt: [
        {
          id: 1,
          name: "24h",
          alias: "24H",
          amount: 24,
          filter: "H"
        },
        {
          id: 1,
          name: "12h",
          alias: "12H",
          amount: 12,
          filter: "H"
        },
        {
          id: 1,
          name: "6h",
          alias: "6H",
          amount: 6,
          filter: "H"
        },
        {
          id: 1,
          name: "3h",
          alias: "3H",
          amount: 3,
          filter: "H"
        },
        {
          id: 1,
          name: "2h",
          alias: "2H",
          amount: 2,
          filter: "H"
        },
        {
          id: 1,
          name: "1h",
          alias: "1H",
          amount: 1,
          filter: "H"
        },
        {
          id: 1,
          name: "30m",
          alias: "30M",
          amount: 30,
          filter: "M"
        },
        {
          id: 1,
          name: "15m",
          alias: "15M",
          amount: 15,
          filter: "M"
        }
      ]
    };
  },
  watch: {
    sortedBy: function() {
      this.createChart(this.mainCanvas, this.data);
    },
    selectedTime: function() {
      this.$emit("timeFrame", this.selectedTime);
    },
    data: {
      handler() {
        this.createChart(this.mainCanvas, this.data);
      },
      deep: true
    }
  },

  methods: {
    chooseTimeFrame(frame) {
      this.selectedTime === frame
        ? (this.selectedTime = null)
        : (this.selectedTime = frame);
    },
    createChart(canvas, chartData) {
      let tempData = [];

      chartData.map(item => {
        if (
          this.sortedBy &&
          this.sortedBy !== "alpha" &&
          item.expansion[this.sortedBy].count[0] === 0
        ) {
          return;
        }
        tempData.push({
          name: item.title,
          size:
            this.sortedBy && this.sortedBy !== "alpha"
              ? item.expansion[this.sortedBy].count[0] + 5
              : item.count[0] + 5,
          value:
            this.sortedBy && this.sortedBy !== "alpha"
              ? item.expansion[this.sortedBy].count[0]
              : item.count[0]
        });
      });
      let countAll = tempData.reduce((a, b) => {
        return  a + b.value
      },0 )

      tempData.map((item,idx)=>{
        tempData[idx] = {...item,perc:((item.value/countAll)*100).toFixed(1)}
      })
      //let counter = naCountriesData.reduce((a, b) => a + b)
      let dataToChart = [{ children: tempData }];
      let chart = anychart.treeMap(dataToChart, "as-tree");
      $("#" + canvas).html("");
      chart.container(canvas);
      let customColorScale = anychart.scales.linearColor();
      customColorScale.colors(["#ffcc00", "#ff6600"]);
      chart.maxDepth(2);
      chart.headers(false);
      chart.colorScale(customColorScale);

      chart.labels().useHtml(true);
      chart.labels().format(
          "<span style='font-weight:bold'>{%name}</span><br>" +
          "<span style='font-weight:bold'>{%value}</span> (%{%perc})"
      );
      chart
          .tooltip()
          .format(
              "Count: {%value}" +
              "\nPerc: {%perc}%"
          );
      chart.padding(0);
      chart.draw();

      let credits = document.getElementsByClassName("anychart-credits");
      $(credits).hide();
    }
  }
};
</script>

<style scoped>
.multi-chart {
  height: 190px;
  width: 100%;
}
.top-buttons {
  display: flex;
  max-width: 100%;
}
.top-buttons .btn {
  flex: 1;
  max-height: 20px;
  padding: 2px 3px !important;
  border-radius: 0px;
}
.top-buttons .btn:focus {
  outline: none;
}
.top-buttons .btn-success {
  border: none;
}
</style>
